import { createBrowserRouter } from 'react-router-dom';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Overview } from './pages/Overview';
import { JiraBoard } from './pages/JiraBoard';
import { Security } from './pages/Security';
import { Repositories } from './pages/Repositories';
import { Sites } from './pages/Sites';
import { Infrastructure } from './pages/Infrastructure';
import { Playbooks } from './pages/Playbooks';
import { Compliance } from './pages/Compliance';
import { Deployments } from './pages/Deployments';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Overview /> },
      { path: 'jira', element: <JiraBoard /> },
      { path: 'security', element: <Security /> },
      { path: 'repositories', element: <Repositories /> },
      { path: 'sites', element: <Sites /> },
      { path: 'infrastructure', element: <Infrastructure /> },
      { path: 'playbooks', element: <Playbooks /> },
      { path: 'compliance', element: <Compliance /> },
      { path: 'deployments', element: <Deployments /> },
    ],
  },
  { path: '*', element: <NotFound /> },
]);
